import { blobToBase64 } from '@maximizer/shared/util';
import { forkJoin, from, map, Observable, of } from 'rxjs';

/** Sent for a file whose type the browser did not report. */
const FALLBACK_MEDIA_TYPE = 'application/octet-stream';

// The thread keeps every upload, so a later question can refer to a file without sending it again.
export interface LangGraphUpload {
  /** The filled copy of a form is named after it: `form.pdf` is attached as `form.filled.pdf`. */
  name: string;
  mediaType: string;
  /** The file's bytes, plain base64 - without the `data:<type>;base64,` prefix. */
  data: string;
}

// `mediaType` replaces the browser's type for every file, for a caller that takes one kind only.
export function readLangGraphUploads(
  files: File[],
  mediaType?: string,
): Observable<LangGraphUpload[]> {
  // forkJoin of nothing completes without emitting, which would skip the run.
  if (files.length === 0) {
    return of([]);
  }
  return forkJoin(
    files.map((file) =>
      from(blobToBase64(file)).pipe(
        map((dataUrl) => ({
          name: file.name,
          mediaType: mediaType ?? (file.type || FALLBACK_MEDIA_TYPE),
          data: dataUrl.slice(dataUrl.indexOf(',') + 1),
        })),
      ),
    ),
  );
}
